//config default
export const firebaseConfig = {
  apiKey: "AIzaSyCLwVIzwu5-NQP1cGIQrjaCnYq5utUGXcM",
    authDomain: "pedidos-3d518.firebaseapp.com",
    databaseURL: "https://pedidos-3d518.firebaseio.com",
    projectId: "pedidos-3d518",
    storageBucket: "pedidos-3d518.appspot.com",
    messagingSenderId: "963114970401"

};

// Sandip's firebase configuration
// export const firebaseConfig = {
//     apiKey: "AIzaSyAzusy10a0pSk-huxJO-DUtK0RoGgqJcpM",
//     authDomain: "restaurantweb-ionic-app.firebaseapp.com",
//     databaseURL: "https://restaurantweb-ionic-app.firebaseio.com",
//     projectId: "restaurantweb-ionic-app",
//     storageBucket: "restaurantweb-ionic-app.appspot.com",
//     messagingSenderId: "120142074708"
//   };



// WEBPACK FOOTER //
// ./src/app/firebase.config.ts